import moment from "moment-timezone";
export const monthlyData = [
    {
        name: "Included Users",
        free: {
            icon: "tick-green",
            color: "green",
            content: "1",
        },
        starter: {
            icon: "tick-green",
            color: "green",
            content: "1",
        },
        smb: {
            icon: "tick-green",
            color: "green",
            content: "3",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Custom",
        },
    },
    {
        name: "Social Profiles",
        free: {
            icon: "tick-green",
            color: "green",
            content: "5",
        },
        starter: {
            icon: "tick-green",
            color: "green",
            content: "5",
        },
        smb: {
            icon: "tick-green",
            color: "green",
            content: "10",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Custom",
        },
    },
    {
        name: "Included Queries",
        free: {
            icon: "tick-green",
            color: "green",
            content: "1",
        },
        starter: {
            icon: "tick-green",
            color: "green",
            content: "1",
        },
        smb: {
            icon: "tick-green",
            color: "green",
            content: "5",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Custom",
        },
    },
    {
        name: "Type of Query",
        free: {
            icon: "tick-green",
            color: "green",
            content: "Sample data only",
        },
        starter: {
            icon: "tick-green",
            color: "green",
            // content: "Display + Data Pull",
            content: "Sample data + Full data",
        },
        smb: {
            icon: "tick-green",
            color: "green",
            content: "Sample data + Full data",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Sample data + Full data",
        },
    },
    {
        name: "Keyword and Hashtag Configuration",
        free: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
        starter: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
        smb: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
    },
    {
        name: "Image Analytics",
        free: {
            icon: "cross",
            color: "red",
            content: "Not Available",
        },
        starter: {
            icon: "cross",
            color: "red",
            content: "Not Available",
        },
        smb: {
            icon: "cross",
            color: "red",
            content: "Not Available",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Advanced",
        },
    },
    {
        name: "Standard Dashboards",
        free: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
        starter: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
        smb: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
    },
    {
        name: "Custom Dashboards",
        free: {
            icon: "cross",
            color: "red",
            content: "Not Available",
        },
        starter: {
            icon: "tick-green",
            color: "green",
            content: "$49 per month for 1 custom dashboard",
        },
        smb: {
            icon: "tick-green",
            color: "green",
            content: "$49 per month for 1 custom dashboard",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Unlimited",
        },
    },
    {
        name: "Reports",
        free: {
            icon: "tick-green",
            color: "green",
            content: "1",
        },
        starter: {
            icon: "tick-green",
            color: "green",
            content: "1",
        },
        smb: {
            icon: "tick-green",
            color: "green",
            content: "5",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Custom",
        },
    },
    {
        name: "Alerts",
        free: {
            content: "1",
            icon: "tick-green",
            color: "green",
        },
        starter: {
            content: "1",
            icon: "tick-green",
            color: "green",
        },
        smb: {
            content: "5",
            icon: "tick-green",
            color: "green",
        },
        enterprise: {
            content: "Custom",
            icon: "tick-green",
            color: "green",
        },
    },
    {
        name: "Additional Queries",
        free: {
            icon: "cross",
            color: "red",
            content: "Not Available",
        },
        starter: {
            icon: "cross",
            color: "red",
            content: "Not Available",
        },
        smb: {
            icon: "cross",
            color: "red",
            content: "Not Available",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Custom",
        },
    },
    {
        name: "Additional Users",
        free: {
            icon: "cross",
            color: "red",
            content: "Not Available",
        },
        starter: {
            icon: "cross",
            color: "red",
            content: "Not Available",
        },
        smb: {
            icon: "cross",
            color: "red",
            content: "Not Available",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Custom",
        },
    },
    {
        name: "Data Sources",
        free: {
            icon: "tick-yellow",
            color: "yellow",
            content: "Standard",
        },
        starter: {
            icon: "tick-yellow",
            color: "yellow",
            content: "Standard",
        },
        smb: {
            icon: "tick-yellow",
            color: "yellow",
            content: "Standard",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Standard + Premium",
        },
    },
    // {
    //     name: "Self Trainable Models",
    //     free: {
    //         icon: "cross",
    //         color: "red",
    //         content: "No",
    //     },
    //     starter: {
    //         icon: "cross",
    //         color: "red",
    //         content: "No",
    //     },
    //     smb: {
    //         icon: "cross",
    //         color: "red",
    //         content: "No",
    //     },
    //     enterprise: {
    //         icon: "tick-green",
    //         color: "green",
    //         content: "Yes",
    //     },
    // },
    {
        name: "Social Media Response",
        free: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
        starter: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
        smb: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
    },
    {
        name: "Social Media Publishing",
        free: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
        starter: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
        smb: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
    },
    {
        name: "Owned Page Analytics",
        free: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
        starter: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
        smb: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
    },
    {
        name: "Public Dashboards",
        free: {
            icon: "cross",
            color: "red",
            content: "No",
        },
        starter: {
            icon: "cross",
            color: "red",
            content: "No",
        },
        smb: {
            icon: "cross",
            color: "red",
            content: "No",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
    },
    // {
    //     name: "Owned Page Analytics",
    //     free: {
    //         icon: "tick-green",
    //         color: "green",
    //         content: "Yes",
    //     },
    //     starter: {
    //         icon: "cross",
    //         color: "red",
    //         content: "No",
    //     },
    //     smb: {
    //         icon: "cross",
    //         color: "red",
    //         content: "No",
    //     },
    //     enterprise: {
    //         icon: "tick-green",
    //         color: "green",
    //         content: "Yes",
    //     },
    // },
    {
        name: "Self-Trainable Sentiment Models",
        free: {
            icon: "cross",
            color: "red",
            content: "No",
        },
        starter: {
            icon: "cross",
            color: "red",
            content: "No",
        },
        smb: {
            icon: "cross",
            color: "red",
            content: "No",
        },
        enterprise: {
            icon: "tick-green",
            color: "green",
            content: "Yes",
        },
    },
];

export const planNumbers = {
    free: {
        users: 1,
        queries: 1,
        alerts: 1,
        reports: 1,
    },
    starter: {
        users: 1,
        queries: 1,
        alerts: 1,
        reports: 1,
    },
    smb: {
        users: 3,
        queries: 5,
        alerts: 5,
        reports: 5,
    },
};

export const myStyle = {
    control: (base) => ({ ...base, border: 0, boxShadow: "none", background: "#F5F6FA", height: "36px", minHeight: "36px" }),
    valueContainer: (provided) => ({
        ...provided,
        display: "flex",
        justifyContent: "center",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            backgroundColor: isSelected ? "#008BFF" : null,
            "&:hover": {
                backgroundColor: isFocused && !isSelected ? "#f2f3ff" : null,
            },
            padding: isSelected ? " 8px 13px" : " 8px 13px",
            marginLeft: isSelected ? "2px" : "0px",
            color: isSelected ? "#fff" : "#1f2e3d",
            borderRadius: "6px",
            opacity: isDisabled ? 0.5 : 1,
        };
    },

    placeholder: (defaultStyles) => {
        return {
            ...defaultStyles,
            color: "#112C5A",
        };
    },
    dropdownIndicator: (provided, state) => ({
        ...provided,
        transform: state.selectProps.menuIsOpen && "rotate(180deg) translateY(5px)",
    }),

    menuList: (base) => ({
        ...base,
        padding: "7px",
        margin: "4px",

        "::-webkit-scrollbar": {
            width: "2px",
        },
        "::-webkit-scrollbar-track": {
            background: "white",
        },
        "::-webkit-scrollbar-thumb": {
            background: "white",
        },
        "::-webkit-scrollbar-thumb:hover": {
            background: "white",
        },
    }),
};

export const activeFilterOptions = [
    { label: "free", value: "free" },
    { label: "Starter", value: "Starter" },
    { label: "Professional", value: "smb" },
    { label: "Enterprise", value: "enterprise" },
];

export const getInvoiceList = (invoiceList, planText) => {
    let invoiceTableList = invoiceList ? invoiceList.slice(0) : [];
    // searching
    let searchtext = planText.trim();

    if (searchtext !== "") {
        let invoices = [];

        invoiceList.forEach((p) => {
            if (p.package_code && p.package_code.toLowerCase().indexOf(searchtext.toLowerCase()) > -1) invoices.push(p);
        });

        invoiceTableList = invoices;
    }

    invoiceTableList = invoiceTableList.sort(function (a, b) {
        return moment(b.invoice_created_at).format("X") - moment(a.invoice_created_at).format("X");
    });
    return invoiceTableList;
};

export const productNames = {
    free: "Free Trial",
    starter: "Starter Plan",
    smb: "Professional Plan",
    enterprise: "Enterprise Plan",
};

const prices = {
    month: {
        starter: "99",
        smb: "299",
    },
    annual: {
        starter: "82",
        smb: "249",
    },
};

export const maskEmail = (email = "") => {
    const [name, domain] = email.split("@");
    const { length: len } = name;
    const maskedName = name[0] + "*****" + name[len - 1];
    const [domain1, domain2] = domain.split(".");
    const maskedDomain = domain1[0] + "****" + ".";
    const maskedEmail = maskedName + "@" + maskedDomain + domain2;
    return maskedEmail;
};

export const generateShortId = () => {
    return Math.random().toString(36).slice(-9);
};
